import * as React from 'react';
import { IMaterialItemProps } from './IMaterialItem';
import './MaterialItem.scss';

const MaterialItem = (props: IMaterialItemProps) => {
    return (
        <>
            {!props.material.isDeleted && (
                <>
                    <button
                        type='button'
                        className={`d-flex justify-content-between align-items-center p-2 material-item ${props.className} ${props.selected ? 'selected' : ''}`}
                        style={{ ...props.style }}
                        onClick={props.onClick}>
                        <div className='material-name'>{props.material.name}</div>
                        <div style={{ width: '20%', height: '30px', background: props.material.color }}></div>
                    </button>
                </>
            )}
        </>
    );
};

export default MaterialItem;
